import React, { useContext } from 'react';

import { ThemeContext } from 'styled-components';
import { getBreakpointFromManor } from 'ctm-components';

import { Typography } from '@comparethemarketau/manor-typography';
import { Picture } from '@comparethemarketau/manor-picture';
import { Link } from '@comparethemarketau/manor-link';
import { Row, Column, Container } from '@comparethemarketau/manor-grid';

import { getAssetFilePath } from '../../summary/common/get_asset_file_path';

const getCarpeeshHandoverWizardPages = function (productDisclosures) {
    const theme = useContext(ThemeContext);

    const carpeeshPolicyDocumentsURL = 'https://carpeesh.com/policy-documents';

    const breakpoint = getBreakpointFromManor();

    let titleStyle = { fontSize: theme.fontSize['3xl'], fontWeight: theme.fontWeight.semibold };
    let contentPaddingSpace = ['28', '84', '28', '84'];
    if (breakpoint === 'xs') {
        contentPaddingSpace = ['24', '36', '24', '36'];
        titleStyle = { fontSize: theme.fontSize.xl, fontWeight: theme.fontWeight.semibold };
    } else if (breakpoint === 'sm') {
        contentPaddingSpace = ['28', '60', '28', '64'];
        titleStyle = { fontSize: theme.fontSize['3xl'], fontWeight: theme.fontWeight.semibold };
    }

    return [
        <Container padding={contentPaddingSpace} key={'page-1'}>
            <Row>
                <Column valign="center" halign="center">
                    <Picture title={'contract'} src={getAssetFilePath('/assets/images/logos/car-insurance/contract-info.svg')} />
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" style={titleStyle}>
                        Introducing the Driver Safety App
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" align="center">
                        To use the features of this product you will be required to download Carpeesh’s
                        {' '}
                        <strong>Driver Safety App</strong>
                        {' '}
                        on your mobile phone
                        within 14 days from the beginning of the period of insurance.
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" align="center">
                        Where the App is not downloaded within 14 days from the beginning of the period of insurance,
                        {' '}
                        <strong>an additional excess of $1,000 will apply on any claim.</strong>
                    </Typography>
                </Column>
            </Row>
        </Container>,
        <Container padding={contentPaddingSpace} key={'page-2'}>
            <Row>
                <Column valign="center" halign="center">
                    <Picture title={'driver app'} src={getAssetFilePath('/assets/images/logos/car-insurance/driver-app.svg')} />
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" style={titleStyle}>
                        How It Works
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" align="center">
                        The Driver Safety App samples your driving data; how far and how safely you drive your car impacts the future premiums you pay,
                        {' '}
                        with good drivers of any age rewarded and unsafe drivers required to pay more.
                    </Typography>
                </Column>
            </Row>
        </Container>,
        <Container padding={contentPaddingSpace} key={'page-3'}>
            <Row>
                <Column valign="center" halign="center">
                    <Picture title={'reminders'} src={getAssetFilePath('/assets/images/logos/car-insurance/reminders.svg')} />
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" style={titleStyle}>
                        Cooling Off Period
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" align="center">
                        This Policy has a 14-day cooling off period. Cancellations after the 14-day cooling off period (but before the expiry date of the
                        policy) will incur a cancellation fee of $50 (plus GST). There is no refund on the one-off Driver Safety App Fee initially charged as
                        part of your premium.
                    </Typography>
                </Column>
            </Row>
            <Row>
                <Column valign="center" halign="center">
                    <Typography variant="body1" align="center">
                        Please refer to the
                        {' '}
                        <Link trackingLabel="PDS link" href={carpeeshPolicyDocumentsURL} target="_blank" underline="none">
                            Product Disclosure Statement,
                        </Link>
                        {' '}
                        and
                        {' '}
                        <Link trackingLabel="SPDS link" href={carpeeshPolicyDocumentsURL} target="_blank" underline="none">
                            Supplementary Product Disclosure Statement
                        </Link>
                        {' '}
                        and
                        {' '}
                        <Link trackingLabel="PEG link" href={carpeeshPolicyDocumentsURL} target="_blank" underline="none">
                            Premium and Excess Guide
                        </Link>
                        {' '}
                        for full details.
                    </Typography>
                </Column>
            </Row>
        </Container>
    ];
};

export { getCarpeeshHandoverWizardPages };
